import { Container } from 'react-bootstrap';
import Card from 'react-bootstrap/Card';
import Col from 'react-bootstrap/Col';
import Row from 'react-bootstrap/Row';
import ilovemd from '../assets/img/ilovemd.png';
import dfrPaper from '../assets/img/dynamic-foveated-paper.png';
import netnote from '../assets/img/netnote.png';
import compIntelMaze from '../assets/img/computational-intelligence-maze.png';
import projectsData from '../assets/contents/projects.json';

const projectImages = {
    ilovemd,
    dfr: dfrPaper,
    netnote,
    ci: compIntelMaze,
};

export const Projects = () => (
    <section id="projects">
        <Container>
            <Row className="projects-header-row">
                <div className="section-header">projects</div>
            </Row>
            <Row xs={1} md={2} className="gx-5 align-items-stretch projects-grid" style={{ '--bs-gutter-y': '2.25rem' }}>
                {projectsData.map((project) => (
                    <Col className="project-col" key={project.id}>
                        <Card
                            className="project-card"
                            as="a"
                            href={project.url}
                            target="_blank"
                            rel="noopener noreferrer"
                        >
                            <div className={`project-banner ${project.visualClass}`}>
                                <img
                                    className="project-image"
                                    src={projectImages[project.id]}
                                    alt={`${project.title} preview`}
                                />
                            </div>
                            <Card.Body>
                                <Card.Title className="project-title">{project.title}</Card.Title>
                                <Card.Text className="project-text">{project.text}</Card.Text>
                            </Card.Body>
                        </Card>
                    </Col>
                ))}
            </Row>
        </Container>
    </section>
);
